export default __webpack_public_path__ + "static/media/Shadow's Mask of Engulfing Twilight.4d288759.jpg";